import { buttonVariants } from "@/components/atoms/buttons";
import AppLink from "@/components/atoms/Links/AppLink";
import { cn } from "@/lib/utils";
import { Content, isFilled } from "@prismicio/client";
import { PrismicRichText, SliceComponentProps } from "@prismicio/react";
import Image from "next/image";

export type TextAndImageProps = SliceComponentProps<Content.TextAndImageSlice>;

const TextAndImage = ({ slice }: TextAndImageProps) => {
  const { title, text, image_position, button, image, title_style } = slice.primary;

  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className={cn(
        "text-dark-primary container my-14 flex flex-col-reverse items-center gap-4 px-7.5 sm:gap-6 md:my-28 md:gap-10 md:px-10 lg:flex-row lg:gap-16 lg:px-16",
        image_position === "Right" && "flex-col lg:flex-row-reverse"
      )}
    >
      {isFilled.keyText(title) && title_style === "Titre 1" ? (
        <h1
          id="text-and-image-title"
          className={cn(
            "font-cabinet-grotesk hidden text-center text-2xl font-medium sm:text-3xl md:text-4xl",
            image_position === "Right" && "block lg:hidden"
          )}
        >
          {title}
        </h1>
      ) : (
        <h2
          id="text-and-image-title"
          className={cn(
            "font-cabinet-grotesk hidden text-center text-2xl font-medium sm:text-3xl md:text-4xl",
            image_position === "Right" && "block lg:hidden"
          )}
        >
          {title}
        </h2>
      )}
      <figure className="relative aspect-square h-full max-h-[500px] w-full max-w-[753px] flex-1 overflow-hidden rounded-lg lg:max-h-[661px]">
        {isFilled.image(image) && (
          <Image src={image.url} alt={image.alt || ""} fill className="absolute object-cover" />
        )}
      </figure>
      <div className="max-w-[753px] flex-1">
        {isFilled.keyText(title) && (
          <h1
            className={cn(
              "font-cabinet-grotesk text-2xl font-medium sm:text-3xl md:text-4xl lg:text-5xl",
              image_position === "Right" && "hidden lg:block"
            )}
          >
            {title}
          </h1>
        )}{" "}
        {isFilled.richText(text) && (
          <PrismicRichText
            field={text}
            components={{
              paragraph: ({ children }) => (
                <p
                  className={cn(
                    "mt-7.5 max-w-[580px] leading-[125%] tracking-[0%]",
                    image_position === "Right" && "mt-0 max-w-none lg:mt-7.5"
                  )}
                >
                  {children}
                </p>
              ),
            }}
          />
        )}
        {isFilled.link(button) && (
          <AppLink
            field={button}
            className={cn("mt-8 h-10.5 font-bold md:mt-4.5 lg:mt-1.5", buttonVariants({ variant: "rounded" }))}
          />
        )}
      </div>
    </section>
  );
};

export default TextAndImage;
